/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.close_menu').on('click', function(){
          $('.menu-item-has-children').find('a').first().removeClass('open');
        });

        $('.menu-item-has-children').each(function(){
          $(this).find('a').first().on('click', function(){
            $(this).toggleClass('open');
            return false;
          });
        });

        $('.wpcf7-form input[type="submit"]').replaceWith('<button id="submit" type="submit" class="btn btn-info">' + $('.wpcf7-form input[type="submit"]').val() +' <i class="icon-arrow-right"></i></button>');

        // Select all links with hashes
        $('a[href*="#"]')
        // Remove links that don't actually link to anything
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                  scrollTop: target.offset().top
                }, 1000, function() {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  $target.focus();
                  if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                  } else {
                    $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                  }
                });
              }
            }
          });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        var miniCadeau = $('.input-hidden-value input[id="Mini Cadeau"]').val();
        var sacCadeau = $('.input-hidden-value input[id="Sac Cadeau"]').val();
        var dolceCadeau = $('.input-hidden-value input[id="Dolce Cadeau"]').val();
        var grandCadeau = $('.input-hidden-value input[id="Grand Cadeau"]').val();
        var belCadeau = $('.input-hidden-value input[id="Bel Cadeau"]').val();
        var sicilyCadeau = $('.input-hidden-value input[id="Sicily Cadeau"]').val();
        $('.cadeau select').on('change', function(){
          var val = $(this).val();
          if(val == 'Mini Cadeau') {
            $('.add_desc_cadeau').text(miniCadeau);
          } else if(val == 'Sac Cadeau') {
            $('.add_desc_cadeau').text(sacCadeau);
          } else if(val == 'Dolce Cadeau') {
            $('.add_desc_cadeau').text(dolceCadeau);
          } else if(val == 'Grand Cadeau') {
            $('.add_desc_cadeau').text(grandCadeau);
          } else if(val == 'Bel Cadeau') {
            $('.add_desc_cadeau').text(belCadeau);
          } else if(val == 'Sicily Cadeau') {
            $('.add_desc_cadeau').text(sicilyCadeau);
          }
        }).triggerHandler('change');
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('.bbox-article').each(function(){
          $(this).hover(
          function() {
            $(this).addClass('noBg');
          }, function() {
              $(this).removeClass('noBg');
          });
        });

        $('video').prop('muted', true);

        $('#mute-video').click( function (){
          if( $('video').prop('muted') ) {
            $('video').prop('muted', false);
            $(this).addClass('active');
          } else {
            $('video').prop('muted', true);
            $(this).removeClass('active');
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  var didScroll;
  var lastScrollTop = 0;
  var delta = 400;
  var navbarHeight = $('.back-to-creation').outerHeight();
  $('.back-to-creation').hide(true);

  $(window).scroll(function(event) {
    didScroll = true;
    $('.back-to-creation').show(true);
  });

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(this).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta)
      return;

    if (st > lastScrollTop && st > navbarHeight ) {
      $('.back-to-creation').removeClass('up').addClass('down');
    } else {
      if (st + $(window).height() < $(document).height()) {
        $('.back-to-creation').removeClass('down').addClass('up');
      }
    }
    lastScrollTop = st;
  }

})(jQuery); // Fully reference jQuery after this point.
